import React from 'react';

interface GroupIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const GroupIcon: React.FC<GroupIconProps> = ({ 
  width = 38, 
  height = 38, 
  className = "" 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 64 64" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="64" height="64" rx="32" fill="#E5E4E2"/>
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M41.6004 25.6C41.6004 30.9019 37.3023 35.2 32.0004 35.2C26.6985 35.2 22.4004 30.9019 22.4004 25.6C22.4004 20.2981 26.6985 16 32.0004 16C37.3023 16 41.6004 20.2981 41.6004 25.6ZM38.4004 25.6C38.4004 29.1346 35.535 32 32.0004 32C28.4658 32 25.6004 29.1346 25.6004 25.6C25.6004 22.0654 28.4658 19.2 32.0004 19.2C35.535 19.2 38.4004 22.0654 38.4004 25.6Z" 
        fill="#0A0A0A"
      />
      <path 
        d="M32.0004 40C21.6414 40 12.8152 46.1255 9.45312 54.7073C10.2722 55.5206 11.1349 56.2899 12.0377 57.0113C14.5412 49.1323 22.3951 43.2 32.0004 43.2C41.6057 43.2 49.4596 49.1323 51.9631 57.0113C52.8658 56.2899 53.7286 55.5206 54.5477 54.7073C51.1856 46.1255 42.3594 40 32.0004 40Z" 
        fill="#0A0A0A"
      />
    </svg>
  );
};

export default GroupIcon; 